<template>
  <div class="strip">
    <div class="columns is-desktop">
      <div class="column is-half-desktop is-half-tablet has-text-center bg-blue is-full">
        <h2 class="subtitle is-size-4-mobile is-marginless is-italic has-text-centered-mobile">
          <b>{{ result }}</b>
        </h2>
        <p class="desc is-size-5-widescreen is-size-6 has-text-centered-mobile">
          {{ description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
const resultDetails = {
  Event: {
    imageName: "ev",
    desc:
      "As the Runner of the event, our job is to approach the capital market experts and arrange the capital market seminar and investment training."
  },
  "Conference Programming": {
    imageName: "cp",
    desc:
      "As the think tank of ICMSS, we conduct the international equity research conference and cooperate with capital market experts."
  },
  "Public Relations": {
    imageName: "pr",
    desc:
      "As the face of ICMSS, our job is to build and maintain a good relationship with the public and stakeholders through various online and offline channels."
  },
  "Marketing Communications": {
    imageName: "mc",
    desc:
      "As the visual powerhouse of ICMSS, we build public awareness through media partnership and graphic communication."
  },
  "Corporate Relations": {
    imageName: "cr",
    desc:
      "As the main source of ICMSS' funding, we deal with corporates and build mutually beneficial partnerships with them."
  },
  Operations: {
    imageName: "op",
    desc:
      "We keep ICMSS running smoothly by providing the most effective and efficient accomodation for each and every activity during the event."
  },
  Logistics: {
    imageName: "lg",
    desc:
      "Our job is to provide nourishments for delegates and committee alike during the event by building partnerships with F&B companies."
  },
  "Delegate Relations": {
    imageName: "dr",
    desc:
      "As the connecting bridge between the committee & delegates, we are responsible for all liaison activities and in providing a memorable experience for all national and international delegates."
  }
};

export default {
  name: "ResultStrip",
  props: {
    result: {
      type: String,
      default: '',
    },
  },
  computed: {
    description() {
      return resultDetails[this.result].desc;
    }
  }
};
</script>

<style scoped>
h2,
p,
b {
  font-family: "Montserrat", sans-serif !important;
}

.strip {
  position: relative; /* Change to relative */
  width: 100%; /* Adjust width to fit parent */
  background: transparent;
  /* Remove left, transform, margin-top, animation */
  animation: none; /* Remove animation */
}

.columns {
  margin: 0 !important;
}

.column {
  padding: 20px !important; /* Adjust padding */
  height: 100%;
  min-height: initial; /* Remove min-height */
  display: flex;
  flex-flow: column;
  justify-content: center;
}

.desc {
  padding: 10px 0; /* Adjust padding */
}

/* Remove @keyframes fly-in */
@media screen and (max-width: 991px) {
  .column {
    min-height: initial; /* Remove min-height */
    padding: 15px !important; /* Adjust padding */
  }

  .strip {
    height: auto;
    position: relative;
    width: initial;
    margin-top: 0; /* Remove margin-top */
  }
}

@media screen and (max-width: 767px) {
  .column {
    min-height: initial; /* Remove min-height */
  }
}

.bg-blue {
  background-color: transparent;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  background-image: none; /* Remove background image */
}

.columns.is-desktop > .is-full {
    width: 100%;
}
</style>
